<input [(ngModel)]="selected"
       [typeahead]="states"
       class="form-control">
